import React from 'react'
import './CardList.scss'
import {useDispatch, useSelector} from 'react-redux';
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import {openDialog} from '../../slices/dialog';
import {deleteBgItem} from '../../api/common';
import ButtonCircle from '../Common/ButtonCircle';
import {EditRmMaterial} from '../Dialog/Rm/EditMaterial';
import {selectSelectedRm} from '../../slices/selected';
import {sanitizeUrl} from '../../helpers/misc';
import {useTranslation} from 'react-i18next';
import {selectRole} from '../../slices/profile';

const RmMaterials = ({materials}) => {
    const dispatch = useDispatch();
    const rm = useSelector(selectSelectedRm);
    const role = useSelector(selectRole);
    const editable = role === "company";
    const {t} = useTranslation();

    const addBgItem = () => {
        if (!rm?.id) return;

        dispatch(openDialog({
            Content: EditRmMaterial,
            title: t("company_rm_editMat_title"),
            props: {docId: rm.id},
            closable: true
        }));
    };

    const onUpdateBgItem = (material) => {
        if (!material || !rm?.id) return;

        dispatch(openDialog({
            Content: EditRmMaterial,
            title: "Materiale Formativo",
            props: {
                docId: rm.id,
                material,
            },
            closable: true
        }));
    };

    const onItemDelete = (itemId, itemType) => {
        if (!rm?.id) return;
        deleteBgItem(rm.id, itemId, itemType, role);
    };

    return (
        <div className="materials card">
            <div className={materials.length > 0 ? "card__header border" : 'card__header'}>
                <h2>{t("company_rm_mat_title")}</h2>
                {editable && <ButtonCircle onClick={() => addBgItem()}><AddIcon/></ButtonCircle>}
            </div>
            <div className="card__content">
                {materials.sort((a, b) => (b.title > a.title ? -1 : 1)).map((mat) => (
                    <div key={mat.id} className="card__item">
                        <div className="card__item__content">
                            <h2 className="title">{mat.title}</h2>
                            <a className="text link" target="_blank" rel="noopener noreferrer"
                               href={sanitizeUrl(mat.link)}>{mat.link?.substring(0, 30)}</a>
                            {mat.description &&
                                <div className="text" dangerouslySetInnerHTML={{__html: mat.description}}/>}
                        </div>
                        {editable && (
                            <div className="card__item__actions">
                                <ButtonCircle onClick={() => onUpdateBgItem(mat)}><EditIcon/></ButtonCircle>
                                <ButtonCircle onClick={() => onItemDelete(mat.id, "MAT")}><DeleteIcon/></ButtonCircle>
                            </div>
                        )}
                    </div>
                ))}
            </div>
        </div>
    )
}

export default RmMaterials

/* export const Materials = ({ materials, docId, editable }) => {
    const dispatch = useDispatch();
    const role = useSelector(selectRole);

    const addBgItem = () => {
        dispatch(openDialog({
            Content: EditBgMaterial,
            title: "Materiale Formativo",
            props: {},
            closable: true
        }));
    };

    const onUpdateBgItem = (type, material) => {
        dispatch(openDialog({
            Content: EditBgMaterial,
            title: "Edita Materiale Formativo",
            props: {
                type,
                material,
            },
            closable: true
        }));
    };

    const onItemDelete = (itemId, itemType) => {
        deleteBgItem(docId, itemId, itemType, role);
    };

    return (
        <div className="materials card">
            <div className={materials.length > 0 ? "card__header border" : 'card__header'}>
                <h2>Materiale Formativo</h2>
                {editable && (
                    <button className="rounded" onClick={() => addBgItem()}>
                        <AddIcon />
                    </button>
                )}
            </div>
            {materials.map((mat) => (
                <div key={mat.id} className="card__item">
                    <div className="card__item__elem"></div>
                    <div className="card__item__content">
                        <h2 className="title">{mat.title}</h2>
                        <p className="text">{mat.link}</p>
                    </div>
                    {editable && (
                        <div className="card__item__actions">
                            <button
                                className="rounded"
                                onClick={() => onUpdateBgItem("LIFE", mat)}
                            >
                                <EditIcon />
                            </button>
                            <button
                                className="rounded"
                                onClick={() => onItemDelete(mat.id, "LIFE")}
                            >
                                <DeleteIcon />
                            </button>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
}; */